import {AvailableSite, Customer} from "../customer-model";
import {UvsModuleModel} from "../uvs-module.model";
import {GatewayType} from "../../interfaces/juconnGateway.response";

export class GeneralGatewayModel {
  selectedCustomer: Customer;
  selectedSite: AvailableSite;
  uvsModules: UvsModuleModel[];
  additionalGateway: boolean;
  addressComment: string;
  locationComment: string;
  constructor() {
    this.selectedCustomer = null;
    this.selectedSite = null;
    this.uvsModules = [];
    this.additionalGateway = false;
  }

  public static initialize(model: GeneralGatewayModel): void {
    if (!model.uvsModules) {
      model.uvsModules = [];
    }
    if (model.additionalGateway === null || model.additionalGateway === undefined) {
      model.additionalGateway = false;
    }
    if (!model.uvsModules.length) {
      model.uvsModules.push({
        modulId: "1",
        uvsType: GatewayType.SM01,
        address: 1
      });
    }
  }
}
